module.exports = __webpack_public_path__ + "score1.mp3";